/**
 * 按日期查询拍卖场次
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 获取拍卖场次列表
// 接口地址   /api/v1/auctions/auction_order/{auction_id}
Mock.mock(/\/auctions\/auction_order\/\d+/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'auction_info': {
      'auction_car_id': 2,
      'order_status_code': 1, // 订单状态码，详细说明见上表1,3,4,5,2对应到产品图
      'car_image': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
      'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座', // 车型名称
      'vin': 'LAV323243JFF2211', // 车架号
      'order_id': 454565511, // 订单编号
      'maximum_price': 10000, // 中标金额，单位：分
      'actual_paid_amount': 15000000, // 实收金额，单位：分
      // 以下为订单关闭时出现的4个字段，若订单状态不属于{关闭订单(3)，仲裁中(4)，已仲裁(5)}，则这些字段的值为空
      // 可通过order_status_code来判断订单状态
      'closed_at': '2017-11-20  20:1', // 订单关闭时间
      'close_reason': '买家违约拒付款', // 关闭理由
      'penalize_amount_info': 0, // 保证金问题
      'close_note': '已和买家协商过了，买家同意关闭买家同意关闭买家同意关闭买家同意关闭买家同意关闭。', // 关闭备注
      // 以下为订单仲裁时(即关闭交易且门店要求扣除车商保证金)出现的字段，若订单状态不是已仲裁(5)或仲裁中(4)，则字段值为空
      'arbitration_result': 1, // 处理结果
      // 以下为订单已收款时出现的字段，若订单并非已收款，则字段值为空
      'paid_date': '2017-11-11  20:11', // 收款时间
      'paid_note': '完成交易' // 备注信息
    },
    'winner_info': {
      'name': '陈金牛',
      'mobile': '13534095201',
      'created_at': '2016-01-21  11:21',
      'organization_type': '二手车经销商',
      'organization_name': '有间二手车行',
      'legal_person_name': '陈建军',
      'province': '广东',
      'city': '深圳',
      'address': '大冲商务中心C座18楼'
    }
  }
})
